module.exports = __webpack_public_path__ + "static/bannner-internacionalismo-5-8bb99b1ff5863e121233a959a38001de.jpeg";